// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1xvVu","content":"LoadingAlert_content__3L_zA"};